import { Box, Button, PasswordInput, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconSend } from "@tabler/icons-react";
import { useRef, useState } from "react";
import { MessageResponse } from "../../../model/MessageResponse";
import { repositoryMaster } from "../../_const/_constVar";
import { NotificationExtension } from "../../extension/NotificationExtension";
import { isNullOrEmpty } from "../../extension/StringExtension";
import style from "./AuthenticationTitle.module.css";

export interface RecordModal {
  userName: string;
  passWord: string;
  code: string;
}

export const Record = () => {
  const countdownRef = useRef(0);
  const containsUpperCase = (value: string) =>
    /[A-Z]/.test(value)
      ? null
      : "Mật khẩu phải chứa ít nhất một chữ cái in hoa!";
  const containsLowerCase = (value: string) =>
    /[a-z]/.test(value)
      ? null
      : "Mật khẩu phải chứa ít nhất một chữ cái thường!";
  const containsSpecialChar = (value: string) =>
    /[!@#$%^&*(),.?":{}|<>]/.test(value)
      ? null
      : "Mật khẩu phải chứa ít nhất một kí tự đặc biệt!";
  const minLength = (value: string) =>
    value.length > 3 ? null : "Mật khẩu phải nhiều hơn 3 kí tự!";
  const maxLength = (value: string) =>
    value.length < 20 ? null : "Mật khẩu phải ít hơn 20 kí tự!";
  const noSpaces = (value: string) =>
    /\s/.test(value) ? "Không được chứa dấu cách!" : null;

  const entity: RecordModal = {
    userName: "",
    passWord: "",
    code: "",
  };

  const form = useForm<RecordModal>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      userName: (value) =>
        value.length < 5 || value.length > 25
          ? "Tên đăng nhập phải từ 5-25 kí tự!"
          : null,
      passWord: (value: string | null) => {
        if (!value) {
          return "Xin vui lòng nhập mật khẩu!";
        }
        const validators = [
          minLength,
          maxLength,
          containsUpperCase,
          containsLowerCase,
          containsSpecialChar,
          noSpaces,
        ];
        for (let validate of validators) {
          const error = validate(value);
          if (error) {
            return error;
          }
        }
        return null;
      },
    },
  });

  const handleSendOTP = async () => {
    const userName = form.getValues().userName; // Replace with your form instance
    if (isNullOrEmpty(userName)) {
      NotificationExtension.Fails("Vui lòng nhập tên người dùng!");
      return;
    }
    const res = await repositoryMaster.get<MessageResponse<boolean>>(
      `/api/v1/Auth/code-v2?userName=${userName}`
    );
    if (res && res.httpStatusCode === 200) {
      if (res.success) {
        NotificationExtension.Success(res?.message ?? "Thành công !");
        setTimeout(() => {
          countdownRef.current = 60;
        }, 1000);
      } else {
        NotificationExtension.Fails(res?.message ?? "Thất bại !");
      }
    }

    try {
    } catch (error) {
      console.error("Error sending OTP:", error);
      NotificationExtension.Fails("Thất bại !");
    }
  };

  const CreateApi = async (data: RecordModal) => {
    try {
      const response = await repositoryMaster.post(
        "/api/v1/Auth/recover-pass-new",
        data
      );
      if (response && response.success === true) {
        NotificationExtension.Success("Cập nhật tài khoản thành công");
        //   setDataUserSign({ name: data.userName, pass: data.password });
        setTimeout(() => {
          modals.closeAll();
        }, 1000);
      } else {
        NotificationExtension.Fails(response.message);
      }
    } catch (error) {
      NotificationExtension.Fails("Cập nhật tài khoản thất bại");
    } finally {
    }
  };

  return (
    <div>
      {" "}
      <Box
        component="form"
        m={0}
        p={0}
        onSubmit={form.onSubmit(async (e: RecordModal) => {
          await CreateApi(e);
        })}
      >
        <TextInput
          label={
            <Text size="sm" fw="bold">
              Tên người dùng
            </Text>
          }
          placeholder="Tên người dùng"
          mt="md"
          {...form.getInputProps("userName")}
        />
        <PasswordInput
          label={
            <Text size="sm" fw="bold">
              Mật khẩu mới
            </Text>
          }
          placeholder="Mật khẩu mới"
          mt="md"
          {...form.getInputProps("passWord")}
        />
        <TextInput
          label={
            <Text c="#000" mb={5} size="sm" fw="bold">
              OTP (bấm icon lá thư bên phải để nhận mã)
            </Text>
          }
          defaultValue="secret"
          placeholder="Nhập OTP..."
          mt="md"
          rightSection={
            <IconSend
              size={24}
              color="#0c68b4"
              onClick={handleSendOTP}
              style={{ cursor: "pointer" }}
            />
          }
          {...form.getInputProps("code")}
        />
        <Button
          mt="xl"
          mb="sm"
          type="submit"
          fullWidth
          bg="#2c84cd"
          variant="light"
          className={style.button_submit}
        >
          <Text c={"#fff"} fw={500} size="lg">
            Cập nhật mật khẩu
          </Text>
        </Button>
      </Box>
    </div>
  );
};
